// Skills Icons
import premierLeagueIcon from "./images/epl-logo.png"
import tacticsIcon from "./images/tactics.png"
import interviewsIcon from "./images/interview.png"
import analysisIcon from "./images/analysis.png"
import opinionsIcon from "./images/opinion.png"
import predictionsIcon from "./images/prediction.png"

// Social Icon
import twitchIcon from "./images/twitch.png"
import twitterIcon from "./images/twitter.png"
import linkedInIcon from "./images/linkedin.png"
import emailIcon from "./images/email.png"
import redditIcon from "./images/reddit.png"

export default {
  //(Please Do Not Remove The comma(,) after every variable)
  //Change The Website Template

  //   Header Details ---------------------
  titleImage: "https://s3.amazonaws.com/external_clips/users/114824/medium/NM5__8R5.jpg?1485937821",
  name: "Alex Keble",
  headerTagline: [
    //Line 3 For Header
    "Freelance Writer,",
    //Line 1 For Header
    "Football Journalist,",
    //Line 2 For Header
    "Tactical Analyst",
  ],
  //   Header Paragraph
  headerParagraph:
    "Covering mostly the English Premier League - writing for the likes of Goal, Football365, Sporting Life, Optus Sport and FourFourTwo",

  //Contact Email
  contactEmail: "enquiries@alexkeble.com",

  // End Header Details -----------------------

  // Work Section ------------------------
  projects: [
    {
      title: "The Independent", //Project Title - Add Your Project Title Here
      para:
          "The Independent is a British online newspaper with world class sports coverage", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc:
      // "https://www.independent.co.uk/vouchercodes/static/image_setting/109/logo/logo.png?height=127",
          "https://store-images.s-microsoft.com/image/apps.30952.9007199266349074.47b8b3ed-7c21-4f11-ab1d-246ee2fcacae.1dde0c8b-a215-4c21-ad78-43dd9fdbbd5b",
      //Project URL - Add Your Project Url Here
      url: "https://www.independent.co.uk/author/alex-keble",
      imgSize: "small",
    },
    {
      title: "The Sportsman", //Project Title - Add Your Project Title Here
      para:
        "Sports stories that matter - For sports fans, by sports fans", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc:
        "https://www.thesportsman.com/media/images/generic-square-social.png",
      //Project URL - Add Your Project Url Here
      url: "https://www.thesportsman.com/contributors/alex-keble",
    },
    {
      title: "Tribal Football", //Project Title - Add Your Project Title Here
      para:
        "Football is life. It never stops. Neither do we.", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc:
        "https://www.tribalfootball.com/images/logo.png",
      //Project URL - Add Your Project Url Here
      url: "https://www.tribalfootball.com/authors/Alex%20Keble",
      imgSize: "small",
    },
    {
      title: "Betfair", //Project Title - Add Your Project Title Here
      para:
          "Betfair is the worlds largest betting exchange", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc:
          "https://www.betopin.com/wp-content/uploads/2019/03/betfair-logo.jpg",
      //Project URL - Add Your Project Url Here
      url: "https://betting.betfair.com/authors/alex-keble/",
    },
    {
      title: "Planet Football", //Project Title - Add Your Project Title Here
      para:
        "A celebration of all that's great about football, past and present. If you love football, you'll love us.", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc:
        "https://pbs.twimg.com/profile_images/765129190844854272/nFOvatrd.jpg",
      //Project URL - Add Your Project Url Here
      url: "http://chetanverma.com/",
    },
    {
      title: "FourFourTwo", //Project Title - Add Your Project Title Here
      para:
          "The biggest football magazine in the world", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc:
          "https://yt3.ggpht.com/ytc/AAUvwnjaQjjvrfgKdME0K47C-7qhqMvw5YnXDsHonLqNIQ=s900-c-k-c0x00ffffff-no-rj",
      //Project URL - Add Your Project Url Here
      url: "https://www.fourfourtwo.com/features/6-good-reasons-why-could-be-highest-scoring-season-premier-league-history",
    },
    {
      title: "Goal", //Project Title - Add Your Project Title Here
      para:
          "Sharing football’s passion, news, insight + with the world", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc:
          "https://secure.static.goal.com/280900/280936_gallery.jpg",
      //Project URL - Add Your Project Url Here
      url: "https://www.goal.com/en-gb",
    },
    {
      title: "Optus Sport", //Project Title - Add Your Project Title Here
      para:
          "Optus Sport is an Australian group of sports channels, owned by Optus, launched in 2016", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc:
          "data:image/jpeg;base64,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",
      //Project URL - Add Your Project Url Here
      url: "https://sport.optus.com.au/articles/os5234/what-has-jose-mourinho-really-changed-at-spurs",
    },
    {
      title: "Football365", //Project Title - Add Your Project Title Here
      para:
          "Football365 primarily covers the Premier League, and takes an informal and humorous approach to dealing with the latest football news", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc:
          "https://pbs.twimg.com/profile_images/787936177357787136/iX9pR4dY_400x400.jpg",
      //Project URL - Add Your Project Url Here
      url: "https://www.football365.com/news/the-treble-forecast-arsenal-huge-clash-with-man-united",
    },

    /*
    If You Want To Add More Project just Copy and Paste This At The End
    ,{
        title: 'Project Five',
        para: 'Something Amazing',
        imageSrc: "",
        url: ''
    }
    */
  ],

  // End Work Section -----------------------

  // About Secton --------------
  aboutParaOne:
    "For as long as I can remember I've been passionate - maybe obsessed - with the beautiful game. I'm very lucky to have established a long career as a freelance football journalist, writing regularly for some of the world's biggest sports websites and digital newspapers - Including The Independent, FourFourTwo, Goal, Football365, The Blizzard, and Tribal Football, amongst others.",
  aboutParaTwo:
    "Originally from Birmingham,  I have the unfortunate pleasure of being an Aston Villa fan, which means I rarely get to write about my own team (unless it's in a negative light!). I was a season ticket holder at Villa Park for many years, before moving to London, where I now live with my fiancé.",
  aboutParaThree:
    "I have an honours degree in English Literature from Queen Mary's University and am studying for a Master's degree in Play Therapy from Roehampton. Besides football, I enjoy travelling, reading, video games and whiskey.",
  aboutImage:
    "https://pbs.twimg.com/profile_images/1353968703554154497/XEKL56NW_400x400.jpg",

  //   End About Section ---------------------

  // Skills Section ---------------

  //   Import Icons from the top and link it here

  skills: [
    {
      img: premierLeagueIcon,
      title: "Premier League",
      para:
        "With more than 20 years of experience glued to every game, the Premier League is my bread and butter, allowing in-depth insight into its history and its future.",
    },
    {
      img: tacticsIcon,
      title: "Tactics",
      para:
        "I specialise in tactical understanding, analysis and predictions of all aspects of the game, it's' players and managers. Tune into my twitch stream for live tactics.",
    },
    {
      img: analysisIcon,
      title: "Analysis",
      para:
        "I provide in-depth analysis before, during and after games, as well as analysis and insight into the overall direction of the sport.",
    },
    {
      img: interviewsIcon,
      title: "Interviews",
      para:
        "I've interviewed many players and staff from across the football industry and pride myself in conducting insightful and thought provoking articles from our conversations.",
    },
    {
      img: opinionsIcon,
      title: "Opinion Pieces",
      para:
        "It's not all about tactics and predictions - I like to research and write creatively about my own thoughts and experiences of the worlds favourite sport.",
    },
    {
      img: predictionsIcon,
      title: "Predictions",
      para:
        "Using statistics and data analysis, I work regularly with many outlets on my thoughts and predictions of upcoming matches, competitions and transfers.",
    },
  ],

  // End Skills Section --------------------------

  //   Promotion Section --------------------------

  promotionHeading: "Heading",
  promotionPara:
    "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
  // End Promotion Section -----------------

  //   Contact Section --------------

  contactSubHeading: "Get in touch for more info",
  social: [
    // Add Or Remove The Link Accordingly
    {
      img: twitterIcon,
      url: "https://twitter.com/alexkeble",
    },
    { img: twitchIcon, url: "https://www.twitch.tv/EPLtactics" },
    {
      img: linkedInIcon,
      url: "https://www.linkedin.com/in/alex-keble-50a79260/",
    },
    {
      img: emailIcon,
      url: "mailto:enquiries@alexkeble.com",
    },
    {
      img: redditIcon,
      url: "https://www.reddit.com/user/EPLtactics/",
    },
  ],

  // End Contact Section ---------------
}

// Thanks for using this template, I would love to hear from you contact me at hello@chetanverma.com
